import Cookies from 'js-cookie';
import { IS_FORCE_DISABLE_SILENT_AUTH, IS_NEED_SILENT_AUTH, IS_PUBLIC, IS_VKT_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

export function initMyTeam() {
    const hasMyTeamCookie = !!Cookies.get('isMyTeam');
    if (IS_VKT_WEBVIEW && !hasMyTeamCookie && !IS_PUBLIC) {
        Cookies.set('isMyTeam', 'true', { path: '/' });
    }

    const hasNeedSilentAuthCookie = !!Cookies.get('isNeedSilentAuth');

    if (IS_VKT_WEBVIEW && IS_NEED_SILENT_AUTH && !hasNeedSilentAuthCookie) {
        Cookies.set('isNeedSilentAuth', 'true', { path: '/' });
    }

    if (IS_FORCE_DISABLE_SILENT_AUTH) {
        Cookies.remove('isNeedSilentAuth', { path: '/' });
    }

    const userAgent = window.navigator.userAgent;
    if (!userAgent.includes('QtWebEngine')) {
        Cookies.remove('isMyTeam', { path: '/' });
        Cookies.remove('isNeedSilentAuth', { path: '/' });
    }
}
